let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("in0CI"), load("hRjg9"), load("joJy8"), load("aHE9G"), load("23MlT")]).then(() => parcelRequire('1yiQ2'));